import { isUUIDV4 } from './general';

const REPORT_COL_MENTION_REGEX = /\[.*?\]\(mention:report-column\/([\w.-]+)\)/g;

/** Check if markdown contains at least one report column mention. */
export function hasReportColMentions(markdown: string): boolean {
  return /\[.*?\]\(mention:report-column\/[\w.-]+\)/.test(markdown);
}

/**
 * Partition mention IDs from markdown into extraction column UUIDs and built-in field names.
 *
 * Markdown mentions are in the format: [Column Name](mention:report-column/{id})
 * where id can be a UUID (extraction columns) or a built-in field name.
 */
export function extractReportColMentionDataFromMarkdown(markdown: string) {
  const selectedColumnIds: string[] = [];
  const selectedBuiltInFields: string[] = [];
  const allIds = [...markdown.matchAll(REPORT_COL_MENTION_REGEX)].map(match => match[1]);

  for (const id of allIds) {
    if (isUUIDV4(id)) selectedColumnIds.push(id);
    else selectedBuiltInFields.push(id);
  }

  return { selectedBuiltInFields, selectedColumnIds };
}
